export default {
  SET_MAIL_BOX: function (state, payloads) {
    state.mailBoxes = payloads;
  }
}
